import React from 'react';
import { Card, Typography, List, Alert } from 'antd';
import { MailOutlined, SafetyOutlined, DeleteOutlined, WarningOutlined } from '@ant-design/icons';
import { PageLayout } from '../../components/PageLayout/PageLayout';

const { Title, Text } = Typography;

const HowToDeleteAccountPage = () => {
    const steps = [
        'Open the email client for the address associated with your BanYano account.',
        <>Compose a new message to: <Text strong style={{ color: '#10b981' }}>contact@banyano.app</Text></>,
        <>Set the Subject line exactly as: <Text strong style={{ color: '#10b981' }}>DELETE ME</Text></>,
        'Send the email.'
    ];

    const processList = [
        {
            icon: <SafetyOutlined style={{ fontSize: 20, color: '#10b981' }} />,
            title: 'Verification:',
            description: 'By sending the request from your registered email address, we verify your identity and ownership of the account.'
        },
        {
            icon: <MailOutlined style={{ fontSize: 20, color: '#10b981' }} />,
            title: 'Confirmation:',
            description: 'Within 48 hours, you will receive a manual acknowledgment from our team confirming that your request has been received.'
        },
        {
            icon: <DeleteOutlined style={{ fontSize: 20, color: '#10b981' }} />,
            title: 'Final Deletion:',
            description: 'Once confirmed, your account profile, login credentials, and all associated personal data will be permanently removed from our servers within 30 days.'
        }
    ];

    return (
        <PageLayout>
            <Card
                variant="outlined"
                style={{
                    textAlign: 'center',
                    border: '2px solid #7a7a7a',
                    
                }}
            >
                <Title
                    level={1}
                    style={{
                        
                        marginBottom: 30
                    }}
                >
                    Account Deletion Request
                </Title>

                <Alert
                    type="info"
                    description={
                        <span style={{ fontSize: 16, lineHeight: 1.8 }}>
                            If you wish to delete your account and all associated data from{' '}
                            <Text strong style={{ color: '#10b981' }}>BanYano</Text>, please follow the simple steps below:
                        </span>
                    }
                    style={{
                        marginBottom: 25,
                        textAlign: 'left',
                        
                        
                        borderRadius: 12
                    }}
                    showIcon={false}
                />

                <div style={{
                    background: 'rgba(255, 255, 255, 0.05)',
                    
                    borderRadius: 8,
                    padding: 20,
                    textAlign: 'left'
                }}>
                    <Title level={2} style={{ fontSize: 20, marginTop: 0 }}>
                        How to request deletion:
                    </Title>
                    <List
                        dataSource={steps}
                        renderItem={(item, index) => (
                            <List.Item style={{ border: 'none', paddingLeft: 0 }}>
                                <Text style={{ color: '#e0e0e0', fontSize: 15, lineHeight: 1.8 }}>
                                    {index + 1}. {item}
                                </Text>
                            </List.Item>
                        )}
                        style={{ marginBottom: 30 }}
                    />

                    <Title level={2} style={{ fontSize: 20 }}>
                        What happens next?
                    </Title>
                    <List
                        dataSource={processList}
                        renderItem={(item) => (
                            <List.Item style={{ border: 'none', alignItems: 'flex-start' }}>
                                <List.Item.Meta
                                    avatar={item.icon}
                                    title={<Text strong style={{ color: '#10b981' }}>{item.title}</Text>}
                                    description={<Text style={{ color: '#e0e0e0', fontSize: 15 }}>{item.description}</Text>}
                                />
                            </List.Item>
                        )}
                    />

                    <Alert
                        type="warning"
                        icon={<WarningOutlined />}
                        description={
                            <Text>
                                <Text strong>Note:</Text> Please be aware that this action is permanent and cannot be undone.
                                Once your data is deleted, it cannot be recovered.
                            </Text>
                        }
                        showIcon
                        style={{
                            marginTop: 30,
                            background: 'rgba(239, 68, 68, 0.1)',
                            borderColor: '#ef4444'
                        }}
                    />
                </div>
            </Card>
        </PageLayout>
    );
}

export default HowToDeleteAccountPage;